import React, { useMemo, useCallback } from 'react';
import { Button } from 'antd';
import { nanoid } from 'nanoid';
import { OAUTH_CONFIG } from '../constants';

// 图片资源导入
import logo_wechat from '../../../../public/asset/images/logo_wechat.svg';
import logo_qq from '../../../../public/asset/images/logo_qq.svg';
import logo_webo from '../../../../public/asset/images/logo_webo.svg';
import logo_guanshi from '../../../../public/asset/images/logo.svg';

/**
 * 第三方登录组件
 * 使用常量配置和性能优化
 */
const ThirdPartyLogin = React.memo(() => {
  const handleOAuthLogin = useCallback(() => {
    const state = nanoid();
    sessionStorage.setItem("auth_state", state);
    const redirectUri = encodeURIComponent(
      `${window.location.protocol}//${window.location.host}/auth/callback?state=${state}`
    );
    const authUrl = `${OAUTH_CONFIG.AUTHORIZE_URL}?client_id=${OAUTH_CONFIG.CLIENT_ID}&redirect_uri=${redirectUri}&response_type=${OAUTH_CONFIG.RESPONSE_TYPE}&scope=${encodeURIComponent(OAUTH_CONFIG.SCOPE)}`;
    window.location.href = authUrl;
  }, []);

  // 使用useMemo优化登录提供商配置，避免不必要的重新创建
  const loginProviders = useMemo(() => [
    { icon: logo_wechat, alt: '微信登录', onClick: () => console.log('微信登录') },
    { icon: logo_qq, alt: 'QQ登录', onClick: () => console.log('QQ登录') },
    { icon: logo_webo, alt: '微博登录', onClick: () => console.log('微博登录') },
    { icon: logo_guanshi, alt: '贯石登录', onClick: handleOAuthLogin }
  ], [handleOAuthLogin]);

  return (
    <>
      <div className='flex flex-row items-center w-full justify-between mt-6'>
        <div className='w-1/3 h-[1px] bg-slate-200'></div>
        <span className='text-sm text-slate-400'>其他登录</span>
        <div className='w-1/3 h-[1px] bg-slate-200'></div>
      </div>
      <div className='flex justify-center space-x-4 mt-4'>
        {loginProviders.map((provider, index) => (
          <Button
            key={index}
            type="text"
            className="p-0 border-none shadow-none"
            onClick={provider.onClick}
          >
            <img
              src={provider.icon}
              alt={provider.alt}
              className={provider.alt === '贯石登录' ? 'rounded-full bg-[#791A3E] p-1' : 'w-10 h-10'}
              style={provider.alt === '贯石登录' ? { width: '39px', height: '39px', objectFit: 'contain' } : undefined}
            />
          </Button>
        ))}
      </div>
    </>
  );
});

ThirdPartyLogin.displayName = 'ThirdPartyLogin';

export default ThirdPartyLogin;